import React, { useState } from "react";
import Button from "../../../shared/Button";
import PersianNumber from "../../../shared/PersianNumber";
import Selectbox from "../../../shared/Select";
const NotificationFilter = ({settabid,tabid} ) => {
 //tabid value ===  //comment //reserve //residence //payment //withdraw//report
  const onChange = key => {
    console.log(key);
  };
  const roleOption = [
    {
      label: "بیشترین اقامتگاه",
      value: "بیشترین اقامتگاه"
    },
    {
      label: "ادمین",
      value: "ادمین"
    },
    {
      label: "میزبان",
      value: "میزبان"
    }
  ];
  return (
    <div className="NotificationFilter flex justify-between items-center mt-[43px] mb-[54px] ">
      <div className="flex gap-[16px]">
        <Button
          onClick={() => settabid("residence") }
          varient={tabid === "residence" ? "primary" : "gray"}

        >
          <div className="flex NotificationFilter__button">
            <PersianNumber number="8" />
            <p> ثبت اقامتگاه</p>
          </div>
        </Button>
        <Button
          onClick={() => settabid("reserve") }
          varient={tabid === "reserve" ? "primary" : "gray"}
        >
          <div className="flex NotificationFilter__button">
            <PersianNumber number="8" />
            <p> درخواست رزرو</p>
          </div>
        </Button>
        <Button
          onClick={() => settabid("report") }
          varient={tabid === "report" ? "primary" : "gray"}
        >
          <div className="flex NotificationFilter__button">
            <PersianNumber number="8" />
            <p> شکایات</p>
          </div>
        </Button>
        <Button
          onClick={() => settabid("comment") }
          varient={tabid === "comment" ? "primary" : "gray"}
        >
          <div className="flex NotificationFilter__button">
            <PersianNumber number="8" />
            <p> دیدگاه ها</p>
          </div>
        </Button>
        <Button
          onClick={() => settabid("payment") }
          varient={tabid === "payment" ? "primary" : "gray"}
        >
          <div className="flex NotificationFilter__button">
            <PersianNumber number="8" />
            <p>برداشت</p>
          </div>
        </Button>
      </div>
      <div>
        <div className="header-selectbox">
          <Selectbox
            defaultValue="بیشترین اقامتگاه"
            // placeholder="بیشترین اقامتگاه"
            option={roleOption}
            className={``}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationFilter;
